import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
interface PaymentModeReportProps {
  dateRange: {
    from: string;
    to: string;
  };
}
const PaymentModeReport: React.FC<PaymentModeReportProps> = ({
  dateRange
}) => {
  // Mock data for the report
  const paymentModeData = [{
    mode: 'Cash',
    transactions: 350,
    amount: 1750000
  }, {
    mode: 'Account Transfer',
    transactions: 280,
    amount: 1400000
  }, {
    mode: 'Partial Payment',
    transactions: 145,
    amount: 725000
  }];
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };
  return <div data-id="element-2336">
      <div className="mb-4 p-3 bg-blue-50 border border-blue-100 rounded-md" data-id="element-2337">
        <h3 className="text-sm font-medium text-blue-800" data-id="element-2338">Report Parameters</h3>
        <p className="text-xs text-blue-600 mt-1" data-id="element-2339">
          Date Range: {dateRange.from} to {dateRange.to}
        </p>
      </div>
      <div className="mb-6" style={{
      height: 300
    }} data-id="element-2340">
        <ResponsiveContainer width="100%" height="100%" data-id="element-2341">
          <BarChart data={paymentModeData} margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5
        }} data-id="element-2342">
            <CartesianGrid strokeDasharray="3 3" data-id="element-2343" />
            <XAxis dataKey="mode" data-id="element-2344" />
            <YAxis yAxisId="left" orientation="left" stroke="#8884d8" data-id="element-2345" />
            <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" data-id="element-2346" />
            <Tooltip formatter={(value, name) => {
            if (name === 'amount') return formatCurrency(Number(value));
            return value;
          }} data-id="element-2347" />
            <Legend data-id="element-2348" />
            <Bar yAxisId="left" dataKey="transactions" name="Transactions" fill="#8884d8" data-id="element-2349" />
            <Bar yAxisId="right" dataKey="amount" name="Amount (USD)" fill="#82ca9d" data-id="element-2350" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="overflow-x-auto" data-id="element-2351">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-2352">
          <thead className="bg-gray-50" data-id="element-2353">
            <tr data-id="element-2354">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2355">
                Payment Mode
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2356">
                Transactions
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2357">
                Amount
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2358">
                Percentage (Amount)
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-2359">
            {paymentModeData.map(item => <tr key={item.mode} className="hover:bg-gray-50" data-id="element-2360">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2361">
                  {item.mode}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2362">
                  {item.transactions}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2363">
                  {formatCurrency(item.amount)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2364">
                  {(item.amount / paymentModeData.reduce((sum, data) => sum + data.amount, 0) * 100).toFixed(2)}
                  %
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-md" data-id="element-2365">
        <div className="flex justify-between items-center" data-id="element-2366">
          <span className="text-sm font-medium text-gray-700" data-id="element-2367">
            Total Transactions:{' '}
            {paymentModeData.reduce((sum, data) => sum + data.transactions, 0)}
          </span>
          <span className="text-sm font-medium text-gray-700" data-id="element-2368">
            Total Amount:{' '}
            {formatCurrency(paymentModeData.reduce((sum, data) => sum + data.amount, 0))}
          </span>
        </div>
      </div>
    </div>;
};
export default PaymentModeReport;